{
    "name": "gwo-pubeditor",
    "version": "0.0.4",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "start:proxy": "ng serve --proxy-config proxy.conf.json",
        "build": "ng build",
        "build:dev": "ng build --configuration develop",
        "build:staging": "ng build --configuration staging",
        "watch": "ng build --watch --configuration local",
        "test": "ng test",
        "test-ci": "ng test --no-watch --no-progress  --code-coverage --browsers=ChromeHeadlessNoSandbox",
        "lint": "ng lint --fix"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.1.0",
        "@angular/cdk": "^19.1.0",
        "@angular/common": "^19.1.0",
        "@angular/compiler": "^19.1.0",
        "@angular/core": "^19.1.0",
        "@angular/forms": "^19.1.0",
        "@angular/material": "^19.1.0",
        "@angular/platform-browser": "^19.1.0",
        "@angular/platform-browser-dynamic": "^19.1.0",
        "@angular/router": "^19.1.0",
        "@eslint/js": "^9.20.0",
        "@ngrx/effects": "^19.0.1",
        "@ngrx/eslint-plugin": "^19.0.1",
        "@ngrx/store": "^19.0.1",
        "@ngrx/store-devtools": "^19.0.1",
        "ngx-cookie-service": "^19.1.2",
        "ng-multiselect-dropdown": "^1.0.0",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "uuid": "^11.0.5",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.1.2",
        "@angular/cli": "^19.1.2",
        "@angular/compiler-cli": "^19.1.0",
        "@types/jasmine": "~5.1.0",
        "angular-eslint": "19.0.2",
        "eslint": "^9.16.0",
        "eslint-config-prettier": "^10.0.1",
        "eslint-plugin-prettier": "^5.2.3",
        "jasmine-core": "~5.5.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "karma-junit-reporter": "^2.0.1",
        "prettier": "3.4.2",
        "typescript": "~5.7.2",
        "typescript-eslint": "8.18.0"
    }
}
